/** Merge legacy name + description into a single Task string for display/edit. */
export function formatActionTask(
  name?: string | null,
  description?: string | null
): string {
  const n = (name ?? '').trim();
  const d = (description ?? '').trim();
  if (n && d) return `${n} — ${d}`;
  return n || d;
}
